module.exports = __webpack_public_path__ + "static/media/chat-icon.9741f0dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chatbot/assets/chat-icon.svg
// module id = 465
// module chunks = 0